import { render } from "./QuestionPanel.vue?vue&type=template&id=21e06a42&scoped=true"
import script from "./QuestionPanel.vue?vue&type=script&lang=js"
export * from "./QuestionPanel.vue?vue&type=script&lang=js"

import "./QuestionPanel.vue?vue&type=style&index=0&id=21e06a42&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21e06a42"]])

export default __exports__